import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { viewCartData } from "../redux/slices/ViewCartSlice";

const PaymentResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { ViewCart } = useSelector((state) => state.viewCart);
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(viewCartData());
  }, [dispatch]);

  useEffect(() => {
    window.gtag('event', 'conversion', {
      send_to: 'AW-11312719347/IQk_CPWQ8_wZEPPLqZIq',
      value: (ViewCart?.finalPrice ?? 0).toFixed(2),
      currency: 'INR',
      transaction_i: ''
    });
  }, []);

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handleBackNavigation = () => {
      navigate("/");
    };
    window.addEventListener("popstate", handleBackNavigation);
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, [navigate]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    const orderId = queryParams.get("orderId");

    if (!status || !orderId) {
      navigate("/error");
      return;
    }

    setOrderId(orderId);
    setPaymentStatus(status);
  }, [location.search, navigate]);

  const handleGoHome = () => {
    navigate("/");
  };

  const getStatusStyles = () => {
    switch (paymentStatus) {
      case "SUCCESS":
        return {
          title: "Payment Successful!",
          message: `Your order ${orderId} has been successfully processed.`,
          bg: "bg-green-100",
          icon: "✅",
          textColor: "text-green-600",
        };
      case "FAILED":
        return {
          title: "Payment Failed",
          message: `Your order ${orderId} could not be processed. Please try again.`,
          bg: "bg-red-100",
          icon: "❌",
          textColor: "text-red-600",
        };
      case "PENDING":
        return {
          title: "Payment Pending",
          message: `Your payment is still processing. Please wait.`,
          bg: "bg-yellow-100",
          icon: "⏳",
          textColor: "text-yellow-600",
        };
      default:
        return {
          title: "Error",
          message: `Invalid payment status. Please try again later.`,
          bg: "bg-gray-100",
          icon: "⚠️",
          textColor: "text-gray-600",
        };
    }
  };

  const { title, message, bg, icon, textColor } = getStatusStyles();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-10">
      <motion.div
        className={`max-w-lg w-full p-8 rounded-xl shadow-lg ${bg}`}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex flex-col items-center space-y-6">
          <motion.div
            className="text-6xl"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            {icon}
          </motion.div>
          <motion.h1
            className={`text-3xl font-semibold ${textColor}`}
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            {title}
          </motion.h1>
          <motion.p
            className="text-lg text-gray-700 text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            {message}
          </motion.p>
          <motion.button
            onClick={handleGoHome}
            className="mt-6 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-lg transition-all duration-200 transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Go to Home
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentResultPage;
